import { createEntityAdapter } from '@reduxjs/toolkit';

import { AppError } from '@vk-hr-tek/core/error';

import { GetSideMenuResponse } from '@app/gen/side_menu';
import { ContentSearchRequest, ContentSearchResponse } from '@app/gen/search';

export interface LayoutState {
  isServiceUnavailable: boolean;
  sidebarState: boolean;
  sideMenuState: GetSideMenuResponse | null;
  isLogoLoaded: boolean;
  search: {
    status: 'idle' | 'loading' | 'complete' | 'failed';
    group: ContentSearchRequest['group'];
    items: ContentSearchResponse | null;
    error: AppError | null;
  };

  logoLoadingStatus: 'idle' | 'loading' | 'complete' | 'failed';
  logoLoadingError: AppError | null;

  sideMenuStatus: 'idle' | 'loading' | 'complete' | 'failed';
  sideMenuError: AppError | null;
}

export const initialState: LayoutState = {
  isServiceUnavailable: false,
  sidebarState: false,
  sideMenuState: null,
  isLogoLoaded: false,
  search: {
    status: 'idle',
    group: undefined,
    items: null,
    error: null,
  },
  logoLoadingStatus: 'idle',
  logoLoadingError: null,

  sideMenuStatus: 'idle',
  sideMenuError: null,
};
export const layoutAdapter = createEntityAdapter();
